// extracted by mini-css-extract-plugin
module.exports = {"genericPage":"GenericPage_genericPage__yP3jR"};